import React from 'react';
import { FileTextIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function TermsOfService() {
  return <section className="py-20 bg-white" data-id="element-288">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-289">
        <div className="mb-12" data-id="element-290">
          <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-bold mb-6" data-id="element-291">
            <FileTextIcon className="w-4 h-4" data-id="element-292" />
            Legal Agreement
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-secondary mb-4" data-id="element-293">
            Terms of Service
          </h1>
          <p className="text-gray-600 text-lg" data-id="element-294">Effective date: March 2026</p>
        </div>

        <div className="space-y-12" data-id="element-295">
          {/* Acceptance */}
          <div data-id="element-296">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-297">
              1. Acceptance of Terms
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-298">
              By accessing or using the services provided by Uzoka Tow Truck
              Service ("Company," "we," "us," or "our"), including our website,
              mobile applications, and roadside assistance services, you agree
              to be bound by these Terms of Service. If you do not agree to
              these terms, please do not use our services.
            </p>
          </div>

          {/* Services Description */}
          <div data-id="element-299">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-300">
              2. Description of Services
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-4" data-id="element-301">
              Uzoka Tow Truck Service provides the following roadside and towing
              services:
            </p>
            <ul className="space-y-3" data-id="element-302">
              {['Emergency towing and vehicle recovery', 'Roadside assistance including flat tire changes and battery jump starts', 'Fuel delivery services', 'Vehicle lockout assistance', 'Mobile tire delivery and installation', 'Digital dispatch and real-time tracking'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-303">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary shrink-0 mt-2.5" data-id="element-304" />
                  <span className="text-gray-600 text-lg" data-id="element-305">{item}</span>
                </li>)}
            </ul>
            <p className="text-gray-600 text-lg leading-relaxed mt-4" data-id="element-306">
              Service availability may vary by location, time of day, and
              weather conditions. We reserve the right to modify, suspend, or
              discontinue any service at any time.
            </p>
          </div>

          {/* Service Requests */}
          <div data-id="element-307">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-308">
              3. Service Requests & Dispatch
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-309">
              When you request a service, you agree to provide accurate
              information about your location, vehicle, and the nature of the
              issue. Our zero-queue digital dispatch system will assign the
              nearest available operator. Estimated arrival times are
              approximate and may vary due to traffic, weather, or demand. We
              are not liable for delays caused by circumstances beyond our
              control.
            </p>
          </div>

          {/* Pricing & Payment */}
          <div data-id="element-310">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-311">
              4. Pricing & Payment
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-4" data-id="element-312">
              Service fees are based on the type of service, distance, time of
              day, and vehicle specifications. You will be provided with an
              estimate before service begins whenever possible. Final charges
              may differ from estimates based on actual conditions encountered.
            </p>
            <div className="bg-accent rounded-[10px] p-6" data-id="element-313">
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-314">
                <strong data-id="element-315">Payment:</strong> We accept major credit cards, debit
                cards, and approved insurance billing. Payment is due upon
                completion of service unless alternative arrangements have been
                made. A late payment fee of 1.5% per month may be applied to
                overdue balances.
              </p>
            </div>
          </div>

          {/* Liability */}
          <div data-id="element-316">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-317">
              5. Limitation of Liability
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-318">
              Uzoka Tow Truck Service exercises reasonable care in performing
              all services. However, to the maximum extent permitted by law, our
              total liability for any claim arising from our services shall not
              exceed the amount paid for the specific service giving rise to the
              claim. We are not liable for pre-existing vehicle damage, personal
              property left in vehicles, or indirect, incidental, or
              consequential damages.
            </p>
          </div>

          {/* Cancellation */}
          <div data-id="element-319">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-320">
              6. Cancellation Policy
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-321">
              You may cancel a service request at no charge before a driver has
              been dispatched. Once a driver is en route, a cancellation fee may
              apply to cover dispatch and travel costs. The cancellation fee
              will be communicated to you at the time of cancellation.
            </p>
          </div>

          {/* Insurance */}
          <div data-id="element-322">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-323">
              7. Insurance & Coverage
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-324">
              We maintain commercial liability insurance as required by law. If
              your roadside assistance is covered by your auto insurance or a
              third-party provider, you are responsible for verifying coverage
              and providing accurate policy information. We will work directly
              with approved insurance partners when applicable, but you remain
              responsible for any charges not covered by your policy.
            </p>
          </div>

          {/* User Conduct */}
          <div data-id="element-325">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-326">
              8. User Conduct
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-4" data-id="element-327">
              When using our services, you agree to:
            </p>
            <ul className="space-y-3" data-id="element-328">
              {['Provide accurate and truthful information when requesting services.', 'Treat our operators and staff with respect and courtesy.', 'Ensure the service area is safe and accessible for our operators.', 'Not use our services for any unlawful purpose.', 'Not interfere with or disrupt our operations or digital systems.'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-329">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary shrink-0 mt-2.5" data-id="element-330" />
                  <span className="text-gray-600 text-lg" data-id="element-331">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Privacy */}
          <div data-id="element-332">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-333">
              9. Privacy & Data
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-334">
              Your use of our services is also governed by our Privacy Policy.
              We collect location data, contact information, and vehicle details
              solely for the purpose of providing and improving our services. We
              do not sell your personal information to third parties.
            </p>
          </div>

          {/* Modifications */}
          <div data-id="element-335">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-336">
              10. Changes to Terms
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-337">
              We reserve the right to update these Terms of Service at any time.
              Changes will be posted on this page with an updated effective
              date. Your continued use of our services after changes are posted
              constitutes acceptance of the revised terms.
            </p>
          </div>

          {/* Governing Law */}
          <div data-id="element-338">
            <h2 className="text-2xl font-bold text-secondary mb-4" data-id="element-339">
              11. Governing Law
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-340">
              These Terms of Service are governed by and construed in accordance
              with the laws of the State of New York. Any disputes arising from
              these terms or our services shall be resolved in the courts of New
              York.
            </p>
          </div>

          {/* Contact */}
          <div className="bg-secondary rounded-[10px] p-8 text-white" data-id="element-341">
            <h2 className="text-2xl font-bold mb-4" data-id="element-342">Questions?</h2>
            <p className="text-white/80 text-lg leading-relaxed mb-6" data-id="element-343">
              If you have any questions about these Terms of Service, please
              contact us:
            </p>
            <div className="space-y-4" data-id="element-344">
              <div className="flex items-center gap-3" data-id="element-345">
                <PhoneIcon className="w-5 h-5 text-primary" data-id="element-346" />
                <span className="text-lg" data-id="element-347">718.210.3110</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-348">
                <MailIcon className="w-5 h-5 text-primary" data-id="element-349" />
                <span className="text-lg" data-id="element-350">legal@uzomatowing.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}